<div>

    <div style="display: flex;">
        <div style="width: 100%">
          <h1 style="font-size: 1.5rem">Personal</h1>
        </div>
    </div>

    <div style="border: 1px solid rgb(225, 219, 219); padding: 20px;">
        Demographic data allows us to decipher different groups and what 
        aspects of their identity, such as age and gender, might 
        influence the way that they respond. It also permits us to understand 
        who are reaching successfully and what proportion of the population 
        we need to work on to ensure 100% inclusivity in the OwlHub Experience
        <p class="voluntary-note">
            Some of these answers are sensitive personal data. Providing them is voluntary:
            choose "Don't want to say" for any question you prefer not to answer.
        </p>
    </div>

    <div class="consent">
        <!-- Wording to be confirmed by legal before release -->
        <p>
            OwlHub will only store your answers to these questions if you explicitly consent. You can
            withdraw your consent at any time, and your answers will then be deleted.
        </p>
        @if (consent) {
            <p><strong>You have given your consent.</strong></p>
            @if (!person_id) {
                @if (!confirming_withdrawal) {
                    <lib-button color="accent" mat-button (click)="confirming_withdrawal = true">Withdraw consent</lib-button>
                } @else {
                    <p>Withdrawing deletes your answers to these questions. Are you sure?</p>
                    <lib-button color="primary" class="consent__cancel" mat-button (click)="confirming_withdrawal = false">Cancel</lib-button>
                    <lib-button color="accent" mat-button (click)="setConsent(false)">Yes, withdraw and delete my answers</lib-button>
                }
            }
        } @else {
            <p><strong>No consent has been given, so your answers cannot be saved.</strong></p>
            @if (!person_id) {
                <lib-button color="primary" mat-button (click)="setConsent(true)">I consent to OwlHub storing my answers</lib-button>
            }
        }
        @if (error) {
            <p class="consent__error">{{ error }}</p>
        }
    </div>

    <div *ngIf="!loading"> 
        <form [formGroup]="form" >
            <div formArrayName="answers">
                <div style="margin: 2rem;" *ngFor="let questionGroup of answers.controls; let i = index" 
                    [formGroupName]="i">
                    <label>
                        {{ personal[i].question}}
                        <span style="color: red;">*</span>
                    </label>
                    <mat-radio-group formControlName="answer_id">
                        <mat-radio-button 
                        style="display: block;" 
                        *ngFor="let option of personal[i]?.answers"
                        [value]="option.answer_id">
                            {{ option.answer }}
                        </mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="questionGroup.get('answer_id')?.touched"></div>
                </div>
            </div>
        </form>
    </div>

    <div style="padding: 0 12rem 1rem">
        <lib-button color="primary" style="padding: 5px;" mat-button (click)="router.navigate(['/'])">Back</lib-button>
        <lib-button color="primary" mat-button (click)="update()" [disabled]="!form.valid">Save</lib-button>
    </div>

    

</div>



  

